import BottomRichText from './bottomRichText'

export default BottomRichText